/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
import { hydrate } from 'react-dom';
export default hydrate;


//////////////////
// WEBPACK FOOTER
// ./~/react-native-web/dist/modules/hydrate/index.js
// module id = 3713
// module chunks = 16